import * as actionTypes from './actionTypes'
// Constants
import { platforms } from '../../constants'

import BasicError from '../../errors'

/**
 * @param {string} type
 */
function createWsAction (type) {
  /**
   * @param {any=} payload
   * @param {string=} platform
   * @param {boolean=} [isReconnect] flag to signify if we are reconnecting or not.
   */
  function action (payload, platform = platforms.LINK, isReconnect = false) {
    return {
      type,
      // TODO: This must check for basic error eventually instead.
      error: payload instanceof Error || payload instanceof BasicError,
      payload,
      meta: { platform, isReconnect }
    }
  }
  return action
}

export const wsAttemptConnect = createWsAction(actionTypes.WS_ATTEMPT_CONNECT)
export const wsDisconnect = createWsAction(actionTypes.WS_DISCONNECT)
export const wsConnectFinished = createWsAction(actionTypes.WS_CONNECT_FINISHED)
export const wsDisconnectFinished = createWsAction(actionTypes.WS_DISCONNECT_FINISHED)
export const wsReconnectFailed = createWsAction(actionTypes.WS_RECONNECT_FAILED)

export const wsClosed = createWsAction(actionTypes.WS_CLOSED)
export const wsError = createWsAction(actionTypes.WS_ERROR)

export const lostConnection = createWsAction(actionTypes.LOST_CONNECTION)

export const receiveServerPing = createWsAction(actionTypes.RECEIVE_SERVER_PING)
export const receiveServerPong = createWsAction(actionTypes.RECEIVE_SERVER_PONG)

export const changeConnectivityChecking = createWsAction(actionTypes.CHANGE_CONNECTIVITY_CHECKING)
export const changePingInterval = createWsAction(actionTypes.CHANGE_PING_INTERVAL)
